@use '../../../../../styles/Colors.scss' as Colors;
@use '../../../../../styles/Constants.scss' as Constants;

.table-header {
	font-size: Constants.$val-fontSizeSmall;

		&>span {
			text-transform: uppercase;
		}

		&>b {
			margin-left: Constants.$val-spacing-s;
		}
}

.additional-filters {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: right;
	gap: Constants.$val-spacing-s;
	margin-top: Constants.$val-spacing-s;
}